import prepaymentJournalsReducer from "./reducers";
export { default as prepaymentJournalsTypes } from "./types";
export { default as prepaymentJournalsOperations } from "./operations";
export default prepaymentJournalsReducer;
